module.exports = __webpack_public_path__ + "static/media/googleAssistant.a6addc3f.svg";